import React from 'react';

interface TimelineItemProps {
  year: string;
  event: string;
  description: string;
  last?: boolean;
}

export default function TimelineItem({ year, event, description, last = false }: TimelineItemProps) {
  return (
    <div className="relative mb-8">
      <div className="flex items-center">
        <div className="z-10 flex items-center justify-center w-16 h-10 bg-blue-600 rounded-full shrink-0">
          <span className="text-white font-bold">{year}</span>
        </div>
        <div className="ml-4">
          <h3 className="text-xl font-bold text-gray-900">{event}</h3>
        </div>
      </div>
      
      {!last && (
        <div className="absolute top-0 left-8 -ml-px h-full w-0.5 bg-blue-200" aria-hidden="true"></div>
      )}
      
      <div className="mt-3 ml-14 text-gray-700">
        {description}
      </div>
    </div>
  );
}